import { render, staticRenderFns } from "./appoint_more.vue?vue&type=template&id=3033f19d"
import script from "./appoint_more.vue?vue&type=script&lang=js"
export * from "./appoint_more.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports